




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Utils } from "@/service/util";
import Number from "@/shared/filters/Number";
import { KbnSkn } from "@/model/KbnSkn";
import requestService from "@/service/requestService";
import PaymentService from "@/service/paymentService";
import { CustomerSave } from "@/model/CustomerSave";
import { Getter, Action } from "vuex-class";
import { INSPECT_TYPE } from "@/model/InspectType";
import { CouponData } from "@/model/Coupon";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { SeibiItem } from "@/model/InspectionSeibi";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { MESSAGE } from "@/model/Message";
import NextageFooter from "@/components/nextageFooter.vue";

@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    TopBarTitle
    , NextageFooter
  }
})
export default class PaymentDetail extends Vue {
  showAside: boolean = true;
  $refs!: {
    confirmDialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  reqService: requestService;
  pmtService: PaymentService;
  sktControll: SocketControllers;
  userService: UserService;
  ippanSeibiService: IppanSeibiService;
  dataForSave: CustomerSave;
  isUserMode: boolean = false;

  updating: boolean = false;
  loadingText: string = MESSAGE.Loading;

  totalAllZn: number = 0;
  totalAllZk: number = 0;
  totalACalcZk: number = 0;

  isExitConnectSocket: boolean = false;

  public utils: Utils = new Utils();

  @Prop() onUserConfirmUpdating: boolean;

  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibi: any;
  @Getter("getManualSeibiData", { namespace: "InspectSeibi" })
  seibiManual: any;

  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: number;
  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: number;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];

  // @Getter("dataForSavePayment", { namespace: "Shohiyou" })
  // shakenShohiyou: ShakenShohiyou;
  @Getter("isConfirm", { namespace: "Shohiyou" })
  isConfirmShohiyou: number;

  @Getter("currentState", { namespace: "Coupon" })
  couponData: CouponData;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("loadData", { namespace: "Payment" })
  loadData: number;
  @Getter("isConfirmNex", { namespace: "Payment" })
  isConfirmPaymentNex: number;

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  @Getter("isConfirm", { namespace: "Option" })
  isConfirmOption: number;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  loading: boolean = false;
  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    if (this.isUserMode) {
      this.sktControll.socketEntry("updateCourseSubscription",this.onUpdateTotal); // catchSocket:08車検コース変更による再描画指示
    }
    this.sktControll.connectSocket();
  }

  created() {
    this.reqService = new requestService();
    this.pmtService = new PaymentService();
    this.userService = new UserService();
    this.ippanSeibiService = new IppanSeibiService();

    if (!this.loadData) {
      this.userService.getAllData();
    }
    if (this.$route.meta == "user") { this.isUserMode = true; }
    this.connectSocket();
  }

  mounted() {
    this.$emit("onActiveSideTab", "paymentdetail");
  }

  onConfirm() {
    let stateLegal56 = this.pmtService.getSumLegal56();
    let stateRecommend = this.pmtService.getSumRecommend();
    let sumLegal56: any = {
      totalZk: stateLegal56.zk,
      totalZn: stateLegal56.zn,
      isConfirm: stateLegal56.flg
    };
    let sumRecommend: any = {
      totalZk: stateRecommend.zk,
      totalZn: stateRecommend.zn,
      isConfirm: stateRecommend.flg
    };

    this.$refs.confirmDialog.onOpen();
    this.dataForSave = this.userService.getDataForSaveAk7(
      this.seibi,
      this.seibiManual,
      sumLegal56,
      sumRecommend
    );
    // console.log(this.dataForSave);
  }

  onSubmitConfirm() {
    this.$set(this, "updating", true);
    this.reqService.savePayment(this.dataForSave).then((res: any) => { // sendSocket:ソケット仮34
      this.$set(this, "updating", false);
    }, () => {
      this.$set(this, "updating", false);
    });
    this.$emit("onConfirmPayment");
  }

  get sum() { // 税込みの合算
    this.totalCalc();
    if ( this.isExcludingTax ) {
      return this.totalACalcZk;
    } else {
      return this.totalAllZk;
    }
  }

  totalCalc() {
    const promise = this.pmtService.setTotalCalc();
    Promise.all([promise]).then(() => {
      const state = this.pmtService.getTotalCalc();
      this.totalAllZn = state.totalSumZn;
      this.totalAllZk = state.totalSumZk;
      this.totalACalcZk = state.totalCalcZk;
    });
  }

  get disableConfirm() {
    // ネクステージ用に外した項目と追加した項目がある
    let judgeFlag = false;
    let listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
    if ( this.isNextageCustom ) {
      judgeFlag = this.isConfirmPaymentNex == 0 ? true : false; // 最低料金の確定を必須とする
    } else {
      judgeFlag = (this.isConfirmRecommend == 0 && listRecommend.length > 0) ? true : false; // おすすめ整備
    }
    
    return (
      (this.isConfirmShohiyou == 0 && !this.ippanSeibiService.isIppanSeibi) ||
      this.isConfirmOption == 0 ||
      this.couponData.isConfirm == 0 ||
      this.isConfirmLegal56 == 0 ||
      judgeFlag
    );
  }

  gotoWorkOrder() {
    this.$router.push({ name: "userworkorder" });
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      if (this.isUserMode) {
        this.$router.push({ name: "reservationNumber" });
      } else {
        this.$router.push({ name: "reservation" });
      }
    });
  }

  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
  onUpdateTotal() {
    this.$set(this, "updating", true);
    setTimeout(() => {
      this.$set(this, "updating", false);
      this.totalCalc(); // 金額更新
    }, 2000);
  }

  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */
}
